import { render, staticRenderFns } from "./post-form-wrapper.vue?vue&type=template&id=62ab1e69&"
import script from "./post-form-wrapper.vue?vue&type=script&lang=js&"
export * from "./post-form-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports